import React from 'react'

// functions
import { stripSlashes } from '~/services/functions'

// style
import { Wrap } from './style'

const InputRadio = ({ label, disabled, nameRadio, onClick,...rest }) => {
  return (
    <Wrap {...rest}>
      <label onClick={onClick}>
        <span>
          <input type="radio" name={nameRadio} disabled={disabled} checked={rest.checked}/>
          <div className="circle-check"></div>
        </span>
        <span>
          {<span dangerouslySetInnerHTML={{ __html: stripSlashes(label) }} />}
        </span>
      </label>
    </Wrap>
  )
}
export default InputRadio